import Vue from 'vue'
import Router from 'vue-router'
import Main from './views/Main.vue'
import About from './views/About.vue'
import News from './views/News.vue'
import Contact from './views/Contact.vue'
import RefractoryProducts from './views/RefractoryProducts.vue'
import MainMobile from './views/Main.mobile.vue'
import HighPolymer from './views/HighPolymer.vue'
import BusinessDetail from './views/BusinessDetail.vue'
import SyntheticRawMaterials from './views/SyntheticRawMaterials.vue'
import SyntheticRawMaterialsDetail from './views/SyntheticRawMaterialsDetail.vue'
import NewsDetail from './views/NewsDetail.vue'
import NewsMobileDetail from './views/NewsDetail.mobile.vue'
import ProductsMobile from './views/RefractoryProducts.mobile.vue'
import ContactMobile from './views/Contact.mobile.vue'
import AboutMobile from './views/About.mobile.vue'
import Cs from './views/Cs.vue'
// h5
import NewsMobile from './views/News.mobile.vue'

import mobileApp from './mobileApp'
Vue.use(Router)
const routesP = [
	{
		path: '/:lang?',
		name: 'home',
		component: Main,
		props: true,
		meta: {
			title: "自立股份，自立集团，高温耐火材料",
			content: '自立股份，自立集团，高温耐火材料'
		}
	},
	{
		path: '/cs/:lang?',
		name: 'cs',
		component: Cs,
		props: true
	},
	{
		path: '/about/:lang',
		name: 'about',
		component: About,
		props: true
	},
	{
		path: '/news/:lang',
		name: 'news',
		component: News,
		props: true
	},
	{
		path: '/contact/:lang',
		name: 'contact',
		component: Contact,
		props: true
	},
	{
		path: '/refractoryProducts/:lang',
		name: 'refractoryProducts',
		component: RefractoryProducts,
		props: true
	},
	{
		path: '/highPolymer/:lang',
		name: 'highPolymer',
		component: HighPolymer,
		props: true
	},
	{
		path: '/businessDetail/:lang',
		name: 'businessDetail',
		component: BusinessDetail,
		props: true
	},
	{
		path: '/syntheticRawMaterials/:lang',
		name: 'syntheticRawMaterials',
		component: SyntheticRawMaterials,
		props: true
	},
	{
		path: '/syntheticRawMaterialsDetail/:lang',
		name: 'syntheticRawMaterialsDetail',
		component: SyntheticRawMaterialsDetail,
		props: true
	},
	{
		path: '/newsDetail/:lang',
		name: 'newsDetail',
		component: NewsDetail,
		props: true
	}
]
const routesM = [
	{
		path: '/:lang?',
		name: 'home',
		component: mobileApp,
		props: true,
		meta: {
			title: "自立股份，自立集团",
			content: '自立股份，自立集团'
		}
	},
	{
		path: '/news-mobile/:lang?',
		name: 'NewsMobile',
		component: NewsMobile,
		props: true
	},
	{
		path: '/news-detail-mobile/:lang?',
		name: 'NewsMobileDetail',
		component: NewsMobileDetail,
		props: true
	},
	{
		path: '/products-mobile/:lang?',
		name: 'Product',
		component: ProductsMobile,
		props: true
	},
	{
		path: '/contact-mobile/:lang?',
		name: 'Contact',
		component: ContactMobile,
		props: true
	},
	{
		path: '/about-mobile/:lang?',
		name: 'About',
		component: AboutMobile,
		props: true
	}
]
let routes = []
if (window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
	routes = routesM
} else {
	routes = routesP
}
const router = new Router({ routes })
router.beforeEach((to, form, next) => {
	
	// if(window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
	// 	window.location.href = ''
	// }
	next()
})
export default router